import React, { FC, useCallback, useEffect, useState } from "react";
import { IUser, PageRoutes, useViewModel } from "../../utils";
import { FilterViewModel, Input, Search } from "../../components";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { FilterMobile } from "../../components/filter/FilterMobile";
import { User } from "../../components/user";
import '../../styles/views/employeesPage/employeesPage.scss';

export const EmployeesPage: FC = observer(() => {
  const filterViewModel = useViewModel(FilterViewModel);
  const [filteredEmployee, setFilteredEmployee] = useState(filterViewModel.members);
  const [search, setSearch] = useState('');

  const navigate = useNavigate();

  const onChooseEmployee = useCallback((id: number) => {
    filterViewModel.setSelectEmployee(id);
    navigate(PageRoutes.CALENDAR_PAGE);
  }, []);

  useEffect(() => {
    filterViewModel.onInit();
  }, []);

  useEffect(() => {
    let filtered = search.length
      ? filterViewModel.members.filter(member => member.fullName?.toLowerCase().includes(search.toLowerCase()))
      : filterViewModel.members;
    
    if (filterViewModel.selectEmployeeId) {
      let filteredElem: IUser;
      filtered = filtered.filter((elem) => {
        if (elem.id === filterViewModel.selectEmployeeId) {
          filteredElem = elem;
          return false;
        }
        return true;
      });
      
      filtered.unshift(filteredElem);
    }
    
    setFilteredEmployee(filtered);
  }, [search, filterViewModel.members]);

  return (
    <>
      <FilterMobile />
      <div className="employees-page">
        <Input
          variant={'rounded'}
          classes='gray search-input'
          placeholder='Поиск'
          value={search}
          onChange={setSearch}
          startIcon={<Search />}
          fastClearable
        />

        <div className="employees">
          {filteredEmployee.map((member) => (
            <User
              key={member.id}
              member={member}
              isSelected={member.id === filterViewModel.selectEmployeeId}
              onClickMember={onChooseEmployee}
            />
          ))}
        </div>
      </div>
    </>
  )
});
